import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import format from 'date-fns/format';
import { InfoOutlined } from '@material-ui/icons';
import Input, { INPUT_TYPES } from '../Input/Input';
import { CHANNEL_VARIANTS_LABEL, CONTEXT_GROUPS } from '../../constants';
import iconList from '../../helpers/getIconList';
const { INCLUDE, EXCLUDE } = CONTEXT_GROUPS;

export const ContextBlock = ({ contextData, inclusion = false }) => {
  if (!contextData.length) {
    return null;
  }

  const blockLabel = inclusion ? 'Include Contexts:' : 'Exclude Contexts:';

  return (
    <div className="mt-4">
      <strong>{blockLabel}</strong>
      <ul className="list-reset m-0">
        {contextData.map(context => {
          return (
            <li key={context.key} className="flex mt-1">
              <div className="w-48">
                <strong>{context.key}</strong>
              </div>
              <div className="flex-1">
                {Array.isArray(context.value)
                  ? context.value.join(', ')
                  : context.value}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

ContextBlock.propTypes = {
  contextData: PropTypes.arrayOf(PropTypes.object),
  inclusion: PropTypes.bool.isRequired,
};

const ChangesetRow = props => {
  const { rowKey, draft, totalApprovals } = props;

  const icon = iconList.find(icon => icon.value === draft.icon);
  const IconComponent = icon ? icon.component : null;

  return (
    <tr
      className={cx('b-2-white', {
        'bg-lightYellow': draft.operation_type === 'UPDATE',
        'bg-lightGreen': draft.operation_type === 'CREATE',
        'bg-lightRed': draft.operation_type === 'DELETE',
      })}>
      <td className="p-2">
        <Input
          id={draft.id}
          name={draft.id}
          type={INPUT_TYPES.CHECKBOX}
          onChange={event => props.toggleRowSelection(event, draft)}
          checked={props.selected[rowKey]}
          inputClassName="box_checkbox"
        />
      </td>
      <td className="p-2">{draft.modified_by}</td>
      <td className="p-2">{format(new Date(draft.modified_at), 'd MMM yyyy')}</td>
      <td className="p-2">{draft.type}</td>
      <td className="p-2">{CHANNEL_VARIANTS_LABEL[draft.variant]}</td>
      <td className="p-2 text-sm">
        <div className="flex">
          <div className="w-48">
            <strong>Name:</strong>
          </div>
          <div>{draft.name}</div>
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Status:</strong>
          </div>
          <div>{draft.online ? 'Online' : 'Offline'}</div>
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Channel display name:</strong>
          </div>
          <div>{draft.display_name}</div>
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Show offline state:</strong>
          </div>
          <div>{draft.show_offline_state ? 'Yes' : 'No'}</div>
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Channel button text:</strong>
          </div>
          <div>{draft.channel_button_text}</div>
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Channel button down text:</strong>
          </div>
          <div>{draft.channel_down_text}</div>
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Destination:</strong>
          </div>
          <div>{draft.destination}</div>
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Channel primary description:</strong>
          </div>
          <div
            className="flex-1"
            dangerouslySetInnerHTML={{
              __html: draft.primary_description,
            }}
          />
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Channel secondary description:</strong>
          </div>
          <div
            className="flex-1"
            dangerouslySetInnerHTML={{
              __html: draft.secondary_description,
            }}
          />
        </div>
        <div className="flex mt-2">
          <div className="w-48">
            <strong>Opening hour:</strong>
          </div>
          <div className="flex-1">{draft.opening_hour.name}</div>
        </div>
        {
          (draft.icon && IconComponent) && (
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Icon:</strong>
              </div>
              <div className="flex-1" style={{ display: 'flex', alignItems: 'center' }}>
                <IconComponent width="1.25rem" height="1.25rem" style={{ marginRight: 5 }} />
                {draft.icon}
              </div>
            </div>

          )
        }
        <ContextBlock contextData={draft[INCLUDE]} inclusion />
        <ContextBlock contextData={draft[EXCLUDE]} inclusion={false} />
      </td>
      <td className="draft_approvers p-2">
        <span>{`${totalApprovals}/2`}</span>
        {Boolean(totalApprovals) && (
          <InfoOutlined className="cursor-pointer" fontSize="small" />
        )}
        {Boolean(totalApprovals) && (
          <span className="draft_approvers__list">
            {draft.first_approver}, {draft.second_approver}
          </span>
        )}
      </td>
    </tr>
  );
};

ChangesetRow.propTypes = {
  rowKey: PropTypes.string.isRequired,
  draft: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  totalApprovals: PropTypes.number.isRequired,
  toggleRowSelection: PropTypes.func.isRequired,
};

export default  ChangesetRow;
